import React from 'react';

import { global } from 'config/Routes';
import MenuItem from 'components/commons/MenuItem';
import { isIosApp } from 'components/features/utils/userStatus';

type MenuProps = {
  className: string | null;
  onNavLinkClick(e: React.MouseEvent, path: string): void;
};

const Menu: React.SFC<MenuProps> = props => {
  const items = global.map((item, i) => {
    if (isIosApp() && item.isIosPremium) return <></>;

    const title = item.menuTitle ?? item.title;
    return (
      <div className="flex-shrink-0" key={item.path}>
        <MenuItem
          path={item.path}
          iconName={item.iconName}
          title={title}
          onNavLinkClick={props.onNavLinkClick}
          subActivePaths={item.subActivePaths}
          isNewIcon={item.isNewIcon}
        />
      </div>
    );
  });

  return (
    <div className={`bg-white shadow ${props.className}`} id="id_menu">
      <nav className="flex items-center justify-between py-2 px-8 container">
        {items}
      </nav>
    </div>
  );
};

export default Menu;
